const data = {
  id: 1,
  title: 'Choose the correct definition of the word.',
  subTitle: 'Chọn định nghĩa đúng của từ.',
  question: 'Pencil',
  answers: [
    { id: 1, answer: 'a piece of furniture that consists of a flat top supported by legs', isCorrect: false },
    { id: 2, answer: 'a type of soft white stone', isCorrect: false },
    { id: 3, answer: 'a narrow pice of woord, of a metal of plastic case, containing a black or coloured substance,user for drawing of writing', isCorrect: true },
  ],
};

export default data;
